export class WorkflowCriteria {
public id: number;
public flow_id: number;
public level: number;
public stage: number;
public criteria_type: string;
public default_criteria:string;
public criteria_sql:string;
public criteria_code: string;  
public created_dt : Date;
public created_by :string;
public update_dt : Date;
public updated_by :string;

constructor(){
    this.id =null;
    this.flow_id =null;
    this.level = null;
    this.stage = null;
    this.default_criteria =null;
    this.criteria_sql = null;
    this.criteria_code = null;
    this.created_dt = null;
    this.created_by =null;
    this.update_dt =null;
    this.updated_by = null;
    this.criteria_type = null;
}
}
